import React from "react";
import { Outlet, useParams } from "react-router-dom";
import { RoutePrefixContext } from "../context/RoutePrefixContext";

const RoutePrefixWrapper = () => {
  const { org_url, site_url } = useParams();
  const routePrefix = `/${org_url}/${site_url}`;
  return (
    <RoutePrefixContext.Provider value={routePrefix}>
      <Outlet />
    </RoutePrefixContext.Provider>
  );
};

export default RoutePrefixWrapper;
